import { useEffect, useState } from "react";
import { Alert, Spinner } from "react-bootstrap";
import { useHistory } from "react-router-dom";

import { useCreateRouteMutation } from "../../../../../api/jeep-rally/routes/routes.hooks";
import { buildRoutePayload, initialRouteForm, validateRouteForm } from "../utils/route.utils";
import RouteForm from "../_components/RouteForm";

const RouteCreatePage = () => {
  const history = useHistory();
  const canManage = (() => {
    try {
      const user = JSON.parse(sessionStorage.getItem("userDetails") || "{}");
      const role = String(user.role || user.roles || "").toLowerCase().trim();
      return role === "admin";
    } catch {
      return false;
    }
  })();

  const [form, setForm] = useState(initialRouteForm);
  const [imageFile, setImageFile] = useState(null);
  const [validationErrors, setValidationErrors] = useState({});

  const {
    mutate: createRoute,
    isLoading,
    isPending,
    error,
    reset,
  } = useCreateRouteMutation();

  const submitting = isLoading || isPending;

  useEffect(() => {
    reset();
    setForm(initialRouteForm);
    setImageFile(null);
    setValidationErrors({});
  }, [reset]);

  const updateField = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
    setValidationErrors((prev) => ({ ...prev, [key]: undefined }));
  };

  const handleImageChange = (file) => {
    setImageFile(file);
    setValidationErrors((prev) => ({ ...prev, track_map_image: undefined }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!canManage) return;

    const nextErrors = validateRouteForm(form, { imageFile });
    setValidationErrors(nextErrors);
    if (Object.keys(nextErrors).length > 0) return;

    const payload = buildRoutePayload(form, { imageFile });

    createRoute(
      { payload },
      {
        onSuccess: () => {
          history.push("/jeep-rally/routes");
        },
      }
    );
  };

  const goBack = () => history.push("/jeep-rally/routes");

  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-2">
            <button
              type="button"
              className="btn btn-link p-0 text-decoration-none"
              onClick={goBack}
              aria-label="Back to routes list"
              title="Back"
            >
              <i className="bi bi-arrow-left fs-4" />
            </button>
            <h4 className="card-title mb-0">Create Route</h4>
          </div>
        </div>

        <div className="card-body">
          {!canManage && (
            <Alert variant="warning" className="mb-4">
              Admin access is required to create routes.
            </Alert>
          )}

          {error && (
            <Alert variant="danger" className="mb-4">
              {error?.response?.data?.message || "Failed to create route."}
            </Alert>
          )}

          {submitting && (
            <div className="d-flex justify-content-center py-2">
              <Spinner animation="border" />
            </div>
          )}

          <RouteForm
            form={form}
            validationErrors={validationErrors}
            submitting={submitting}
            submitLabel="Create Route"
            submittingLabel="Creating..."
            readOnly={!canManage}
            imageFile={imageFile}
            onSubmit={handleSubmit}
            onFieldChange={updateField}
            onImageChange={handleImageChange}
            onBack={goBack}
          />
        </div>
      </div>
    </div>
  );
};

export default RouteCreatePage;

